import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-drag-dots-icon',
  standalone: true,
  template: `
    <svg
      [attr.width]="width()"
      [attr.height]="height()"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.167 4.16667C14.167 3.25 13.417 2.5 12.5003 2.5C11.5837 2.5 10.8337 3.25 10.8337 4.16667C10.8337 5.08333 11.5837 5.83333 12.5003 5.83333C13.417 5.83333 14.167 5.08333 14.167 4.16667Z"
        [attr.fill]="color()" />
      <path
        d="M9.16699 4.16667C9.16699 3.25 8.41699 2.5 7.50033 2.5C6.58366 2.5 5.83366 3.25 5.83366 4.16667C5.83366 5.08333 6.58366 5.83333 7.50033 5.83333C8.41699 5.83333 9.16699 5.08333 9.16699 4.16667Z"
        [attr.fill]="color()" />
      <path
        d="M9.16699 9.99967C9.16699 9.08301 8.41699 8.33301 7.50033 8.33301C6.58366 8.33301 5.83366 9.08301 5.83366 9.99967C5.83366 10.9163 6.58366 11.6663 7.50033 11.6663C8.41699 11.6663 9.16699 10.9163 9.16699 9.99967Z"
        [attr.fill]="color()" />
      <path
        d="M9.16699 15.8337C9.16699 14.917 8.41699 14.167 7.50033 14.167C6.58366 14.167 5.83366 14.917 5.83366 15.8337C5.83366 16.7503 6.58366 17.5003 7.50033 17.5003C8.41699 17.5003 9.16699 16.7503 9.16699 15.8337Z"
        [attr.fill]="color()" />
      <path
        d="M14.167 15.8337C14.167 14.917 13.417 14.167 12.5003 14.167C11.5837 14.167 10.8337 14.917 10.8337 15.8337C10.8337 16.7503 11.5837 17.5003 12.5003 17.5003C13.417 17.5003 14.167 16.7503 14.167 15.8337Z"
        [attr.fill]="color()" />
      <path
        d="M14.167 9.99967C14.167 9.08301 13.417 8.33301 12.5003 8.33301C11.5837 8.33301 10.8337 9.08301 10.8337 9.99967C10.8337 10.9163 11.5837 11.6663 12.5003 11.6663C13.417 11.6663 14.167 10.9163 14.167 9.99967Z"
        [attr.fill]="color()" />
    </svg>
  `,
})
export class DragDotsIconComponent {
  width = input<string>('20');
  height = input<string>('20');
  color = input<string>('#6B7280');
}
